module.exports = __webpack_public_path__ + "static/media/facultyPhiLogo.394974a9.png";